import Vue from 'vue';
import tv9rlRcoLink from './components/tv9rl-rco-link.vue';

Vue.component('tv9rl-rco-link', tv9rlRcoLink);

new Vue({
	el: '[data-layout-id=TV9RL-app]'
});
